import { Component, OnInit } from '@angular/core';
import { Alert } from '../shared/alert';
import { IdPRolesMapping } from '../models/idp_roles_mapping';
import { AppTitle } from '../shared/title';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../services/identity.service';
import { validateToken } from '../services/account.service.moc';
import { dateFormat, isDateSet } from '../shared/date_helper';
import { FindIdPRolesMapping } from '../models/find_idp_roles_mapping';
import { IdPRolesMappingTextSearch } from '../models/idp_roles_mapping_text_search';
import { Subscription, Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-roles-mapping',
  styles: [`
    .tag {
      margin-right:2px;
      background-color:#e0e0e0;
      border-radius:4px;
      padding:5px;
    }
  `],
  template: `
  <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-6 col-md-6 col-xs-12">
          <alert [alert]="msg" style="display:block;"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-8 col-md-7 col-xs-12">
          <button type="button" class="btn btn-large btn-primary" (click)="add()">Add New</button>
          <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
      </div>
      <div class="col-lg-4 col-md-5 col-xs-8">
					<div class="input-group">
						<input class="form-control" type="text" (keyup.enter)="refresh()" [(ngModel)]="fobj.query" placeholder="Search"/>
						<span class="input-group-btn">
							<button class="btn btn-default" type="button" (click)="refresh()"> <span class="glyphicon glyphicon-search"></span> </button>
						</span>
					</div>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-12 col-md-12 col-xs-12">
        <div class="card">
          <table class="table">
            <thead>
              <tr>
                  <th>IdP Name</th>
                  <th>AcctNumber</th>
                  <th>Organization</th>
                  <th>Organization Mapping</th>
                  <th>Service Name</th>
                  <th>Service Roles</th>
                  <th>Service Roles Mapping</th>
                  <th>Updated At</th>
                  <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of data; let i = index">
                <td style="width:12%;">{{ row.idpName }}</td>
                <td style="width:12%;">{{ hexAcctNumber(row.orgAcctNumber) }}</td>
                <td style="width:12%;">{{ row.orgName }}</td>
                <td style="width:12%;">{{ row.accountGroups }}</td>
                <td style="width:12%;">{{ row.serviceId }}</td>
                <td style="width:11%;">
                <span class="tag" *ngFor="let role of row.serviceRoles.split(','); let j = index" style="padding: 2px 4px; display: inline-block; margin-bottom: 3px; margin-right: 3px;">{{role}}</span>
                </td>
                <td style="width:11%;">{{ row.serviceRolesGroups }}</td>
                <td style="width:11%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
                <td style="width:7%;">
                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                    <span title="Remove Roles Mapping" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="remove(row)" style="cursor:pointer;"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" *ngIf="data.length > 0" style="margin-top:10px;">
          <div class="col-lg-5">
              <button class="btn btn-default" type="button" title="First Page" [disabled]="disablePreviousPage" (click)="firstPage()">&lt;&lt;</button>
              <button class="btn btn-default" type="button" title="Previous Page" [disabled]="disablePreviousPage" (click)="prevPage()">&lt;</button>
              <span>{{getFromPage()}}-{{getToPage()}} of {{rowCount}}</span>
              <button class="btn btn-default" type="button" title="Next Page" [disabled]="disableNextPage" (click)="nextPage()">&gt;</button>
          </div>
      </div>
    </div>
  `
})
export class RolesMappingComponent implements OnInit {
  data: IdPRolesMapping[];
  msg: Alert;
  msgHead: Alert;
  acctNumber: string;
  hasAccess: boolean;
  maxPageSize: number;
	fobj: IdPRolesMappingTextSearch;
	fromPage: number;
	toPage: number;
	rowCount: number;
	disablePreviousPage: boolean;
	disableNextPage: boolean;
	queryParam: string;
	pageSizeParam: string;
	pageParam: string;
	private subscriptionQueryParams: Subscription;

  constructor(private title: AppTitle, private activatedRoute: ActivatedRoute, private idsvc: IdentityService, private router: Router) {
    this.hasAccess = true;
    this.msg = new Alert();
    this.msgHead = new Alert();
    title.setTitles({
			title: 'Roles Mapping',
			dashboard: 'Roles Mapping'
		});
		this.title.setBreadcrumbs([
			{ title: 'Roles Mapping', link: `` }
    ]);
    this.maxPageSize = 20;
		this.fobj = new IdPRolesMappingTextSearch()
    this.fobj.pageSize = this.maxPageSize;
    this.data = [];

    this.fromPage = 0;
		this.toPage = 0;
		this.rowCount = 0;
		this.disablePreviousPage = true;
		this.disableNextPage = true;
		this.subscriptionQueryParams = activatedRoute.queryParams.subscribe(
			(params) => {
				this.queryParam = params['query'];
				this.pageSizeParam = params['pageSize']
				this.pageParam = params['page']
				this.setFormNavParams(this.fobj);
			}
		);
  }

  ngOnInit() {
    this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
    if (this.acctNumber != null) {
			this.idsvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.idsvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.loadData();
  }

  loadData() {
    this.data = [];
    this.idsvc.textSearchIdPRolesMappingApi(this.acctNumber, this.fobj).subscribe((rows: IdPRolesMapping[]) => {
			for (let e of rows) {
				this.data.push(e);
			}
			this.rowCount = rows.length;
			this.disablePreviousPage = this.fobj.page == 1;
			this.maxPageSize = this.fobj.pageSize;
			if (this.data.length >= this.maxPageSize) {
				this.fromPage = (this.maxPageSize * (this.fobj.page - 1)) + 1;
				this.toPage = (this.maxPageSize * (this.fobj.page));
			} else {
				this.fromPage = (this.maxPageSize * (this.fobj.page - 1)) + 1;
			}

			this.idsvc.textSearchCountIdPRolesMappingApi(this.acctNumber, this.fobj).subscribe(resp => {
				let count = resp.count;
				this.rowCount = count;
				if (this.data.length < this.maxPageSize) {
					this.toPage = count;
				}
				this.disableNextPage = this.getToPage() >= count;
			}, err => {
				console.log(err);
				if (this.idsvc.isErrNotFound(err)) {
					this.msg.warning(this.idsvc.getUserError(err));
				} else {
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				}
			});
		}, err => {
			console.log(err);
			if (this.idsvc.isErrNotFound(err)) {
				this.msg.warning(this.idsvc.getUserError(err));
			} else {
				if (this.idsvc.isErrUnauthorized(err)) {
					this.hasAccess = false;
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				} else {
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				}
			}
		});
  }

  refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
  }

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
  }

  add() {
    this.router.navigate([`idp/${this.acctNumber}/roles-mapping/add`]);
		return;
  }

  remove(row: IdPRolesMapping) {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.idsvc.removeIdPRolesMappingApi(this.acctNumber, row.id)
			.subscribe(res => {
				this.data.splice(this.data.indexOf(row), 1);
			}, err => {
				console.log(err);
				let e = this.idsvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

  edit(row: IdPRolesMapping) {
		this.router.navigate([`idp/${this.acctNumber}/roles-mapping/${row.id}/edit`]);
		return;
  }

  setNavParams(req: IdPRolesMappingTextSearch): Observable<boolean> {
		var params: any = {};

		params['query'] = req.query;
		params['page'] = req.page;
		params['pageSize'] = req.pageSize;

		let p = this.router.navigate([`idp/${this.acctNumber}/roles-mapping`], { queryParams: this.idsvc.params(params) });

		return Observable.create((observer: Observer<boolean>) => {
			p.then(() => {
				observer.next(true);
				observer.complete();
			});
		});
	}

  setFormNavParams(f: IdPRolesMappingTextSearch) {
		let dec = decodeURIComponent;
		f.query = this.queryParam != null ? dec(this.queryParam) : '';
		f.pageSize = this.pageSizeParam != null ? parseInt(dec(this.pageSizeParam)) : 20;
		f.page = this.pageParam != null ? parseInt(dec(this.pageParam)) : 1;
  }

  getFromPage(): number {
		return this.fromPage;
	}

	getToPage(): number {
		return this.toPage;
	}

	prevPage() {
		if (this.fobj.page > 1) {
			this.fobj.page -= 1;
			this.setNavParams(this.fobj).subscribe(() => {
				this.loadData()
			});
		}
	}

	firstPage() {
		if (this.fobj.page > 1) {
			this.fobj.page = 1;
			this.setNavParams(this.fobj).subscribe(() => {
				this.loadData()
			});
		}
	}

	nextPage() {
		if (this.data.length >= this.maxPageSize) {
			this.fobj.page = this.fobj.page + 1;
			this.setNavParams(this.fobj).subscribe(() => {
				this.loadData()
			});
		}
	}

	leftPad(val: string, size: number, ch: string): string {
		var result = String(val);
		if (!ch) {
			ch = " ";
		}
		while (result.length < size) {
			result = ch + result;
		}
		return result;
	}

	hexAcctNumber(num: number): string {
		//sign >>> is Zero-fill right shift
		return this.leftPad((num >>> 0).toString(16), 8, '0').toUpperCase();
	}

}
